const URL = (to, props) => {
  const query = new URLSearchParams(props.location.search);
  if (props.bizslug) {
    query.set('bizslug', props.bizslug);
  }

  return `${to}?${query.toString()}`;
};

export const SendTo = (path, props) => {
  const params = new URLSearchParams(window.location.search);
  return props.history.push(`${path}?${params.toString()}`);
};

export default URL;
